package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.cards.GenericFormCardNew
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.dynamicfields.DynamicAddForm
import io.horion.cv.components.widgets.AjouterBoutton
import io.horion.cv.di.koinGet
import io.horion.cv.models.Job
import io.horion.cv.models.Tags
import io.horion.cv.utils.Colors
import io.horion.cv.viewModel.JobViewModel
import org.jetbrains.compose.web.css.px


@OptIn(DelicateApi::class)
@Composable
fun TagsContent() {
    val jobViewModel = koinGet<JobViewModel>()
    val jobUiState = jobViewModel.jobUiState
    val tagsFromVM = jobUiState.currentJob.tags
    val breakpoint = rememberBreakpoint()

    LaunchedEffect(Unit) {
        if (tagsFromVM.isEmpty()) {
            jobViewModel.updateTag(0, "")
            jobViewModel.editingTag = "tag-0"
        }
    }

    Column(
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        tagsFromVM.forEachIndexed { index, tag ->
            val tempId = "tag-$index"

            val tagObj = remember(tag) {
                Tags(id = tempId, tag = tag)
            }

            GenericFormCardNew(
                item = tagObj,
                isEditing = jobViewModel.editingTag == tempId,
                onEdit = { jobViewModel.editingTag = tempId },
                onDelete = {
                    jobViewModel.deleteTag(index)
                    if (jobViewModel.jobUiState.currentJob.tags.isEmpty()) {
                        jobViewModel.updateTag(0, "")
                        jobViewModel.editingTag = "Tag-0"
                    } else {
                        jobViewModel.editingTag = null
                    }
                },
                onComplete = { jobViewModel.editingTag = null },
                getSummary = { tag ->
                    if (tag.tag.isNotBlank()) {
                        SummaryData(title = tag.tag, subtitle = "")
                    } else null
                },
                getDefaultText = { "[Tag ]" },
                formContent = { s, onDel, onComp ->
                    DynamicAddForm(
                        index = index,
                        onDelete = onDel,
                        onComplete = onComp,
                        label = "Tag",
                        value = tag,
                        onValueChange = { tg ->
                            jobViewModel.updateTag(index,tg) }
                    )
                },
                isMobile = breakpoint <= Breakpoint.MD,
                isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD
            )
        }


        AjouterBoutton(
            text = "Ajouter un tag ",
            onClick = {

                val nextIndex = tagsFromVM.size
                jobViewModel.updateTag(nextIndex, "")
                jobViewModel.editingTag = "tag-$nextIndex"
            },
            isMobile = breakpoint < Breakpoint.SM,
            isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD,
            color = Colors.black
        )
    }
}